class DynamicDates extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    const el = this.querySelector('[data-dynamic-date]');
    if (!el) return;

    const minDays = parseInt(el.dataset.minDays) || 5;
    const maxDays = parseInt(el.dataset.maxDays) || 10;
    const text = el.dataset.text || '';
    const dateFormat = this.dataset.dateFormat || 'day_mm_dd';
    const dayLabels = this.dataset.dayLabels
      ? this.dataset.dayLabels.split(',').map(s => s.trim())
      : ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
    const monthLabels = this.dataset.monthLabels
      ? this.dataset.monthLabels.split(',').map(s => s.trim())
      : ['January','February','March','April','May','June','July','August','September','October','November','December'];

    function ordinal(n) {
  return n;
}

    function formatDate(date) {
  const day = date.getDate();
  const month = date.getMonth();
  const dayName = dayLabels[date.getDay()];
  const monthName = monthLabels[month];

  // Handle preset format keys
  const formats = {
    'day_mm_dd': dayName + ', ' + monthName + ' ' + ordinal(day),
    'mm_dd': monthName + ' ' + ordinal(day),
    'mm_dd_yyyy': monthName + ' ' + day + ', ' + date.getFullYear(),
    'dd_mm': ordinal(day) + ' ' + monthName,
    'dd_mm_yyyy': ordinal(day) + ' ' + monthName + ' ' + date.getFullYear()
  };

  if (formats[dateFormat]) return formats[dateFormat];

  // Fallback: treat as pattern
  return dateFormat
    .replace('month_name', monthName)
    .replace('day_name', dayName)
    .replace('month', month + 1)
    .replace('day_ordinal', ordinal(day))
    .replace('day', day);
}

    const now = new Date();
    const start = new Date(now);
    start.setDate(now.getDate() + minDays);
    const end = new Date(now);
    end.setDate(now.getDate() + maxDays);

    el.innerHTML = text
      .replace('[start_date]', formatDate(start))
      .replace('[end_date]', formatDate(end));
  }
}

customElements.define('dynamic-dates', DynamicDates);

// Re-run on all existing elements in case they loaded before the script
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('dynamic-dates').forEach(el => {
    if (el.render) el.render();
  });
});
